import { useState, useEffect, useCallback } from "react";
import { REGISTRATION_RULES_API, fetchWithAuth } from "../utils/api";

/**
 * Hook to fetch and manage available competition categories from registration rules
 */
export function useCompetitionCategories() {
  const [competitionCategories, setCompetitionCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCompetitionCategories = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Fetch registration rules to get competition categories
      const rulesData = await fetchWithAuth(REGISTRATION_RULES_API);
      
      // Extract competition categories from registration rules
      const categoriesList = rulesData?.competitionCategories || [];
      
      // Normalize competition categories to get labels
      const normalizedCategories = categoriesList
        .map(category => category.label || category.name || category.typeCode)
        .filter(label => label && label.trim() !== "")
        .filter((label, index, arr) => arr.indexOf(label) === index) // Remove duplicates
        .sort(); // Sort alphabetically
      
      console.log('Fetched competition categories from registration rules:', normalizedCategories);
      setCompetitionCategories(normalizedCategories);
    } catch (err) {
      console.error("Error fetching competition categories:", err);
      setError(err.message || "Failed to load competition categories");
      setCompetitionCategories([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Load competition categories on mount
  useEffect(() => {
    fetchCompetitionCategories();
  }, [fetchCompetitionCategories]);

  return {
    competitionCategories,
    loading,
    error,
    refetchCompetitionCategories: fetchCompetitionCategories
  };
}






